<template>
  <v-container fluid>
    <v-skeleton-loader
      :loading="loading"
      type="table"
    >
      <!-- Content after loading goes here -->
      <v-data-table
        :headers="betalingsheaders"
        :items="betalinger"
        :items-per-page="50"
        :loading="loading"
        class="elevation-1"
      >
      <!-- <template v-slot:[`item.active`]="{ item }">
        <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
      </template>
      <template v-slot:[`item.nyhedsbrev`]="{ item }">
        <v-simple-checkbox v-model="item.nyhedsbrev" disabled></v-simple-checkbox>
      </template> -->
      </v-data-table>
    </v-skeleton-loader>
    <br/>
    <v-btn color="primary" @click="download">Download til Excel</v-btn>
  </v-container>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'Betalinger',

  data: () => ({
    loading: true,
    betalingsheaders: [
      {
        text: 'Tidspunkt',
        value: 'updatedAt',
        align: 'start'
      },
      {
        text: 'Medlemsnummer',
        value: 'medlemsnummer'
      },
      {
        text: 'Betaingsnummer',
        value: 'id'
      },
      {
        text: 'Navn',
        value: 'navn'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Beløb',
        value: 'paymentAmount'
      },
      {
        text: 'MobilePayID',
        value: 'PaymentMobilePayID'
      },
      {
        text: 'Internt ID',
        value: 'PaymentExternalID'
      },
      {
        text: 'Status',
        value: 'PaymentState'
      }
    ],
    betalinger: null,
    csvTest: null
  }),
  methods: {
    async download () {
      const betalingsData = await MedlemsService.betalingsData()
      this.csvTest = this.$papa.unparse(betalingsData.data, {
        delimiter: ';'
      })
      this.$papa.download(this.csvTest, 'Betalingsdata')
    }
  },
  async mounted () {
    const betalingData = await MedlemsService.betalingsData()
    this.betalinger = betalingData.data
    this.loading = false
  }
}
</script>
